import { isObject, noop } from 'lodash';

export const scrollToFirstError = (errors = {}, getRef = noop, callback = noop) => {
  let error = Object.keys(errors)[0];
  if (!error) return;

  if (isObject(errors[error]) && !errors[error].defaultMessage) {
    error = `${ Object.keys(errors)[0] }.${ Object.keys(errors[error])[0] }`;
  }

  const container = getRef();
  if (error.indexOf('_error') > -1 && container) {
    return setTimeout(() => container.scrollTop = container.scrollHeight, 500);
  }

  const el = document.querySelector(`[name="${ error }"]`);
  if (!el) return;

  const position = el.parentNode.getBoundingClientRect().top || 0;

  container.scrollTop += (position - container.getBoundingClientRect().top - 70);

  callback(error);
};
